export const RT = {
  olive: "#6f7c4d",
  oliveDark: "#5c6a3c",
  cta: "#557c2e",
  ctaPress: "#496c27",
  ink: "#23272f",
  muted: "#7c8593",
  line: "#eceef0",
  bg: "#f6f7f8",
  good: "#3f8f3a",
  orange: "#FF7B1C",
  orangeBg: "#fff0e4",
  orangeLine: "#ffd9bd",
  field: "#fcfcfb",
  fieldLine: "#e3e6ea",
  chipbg: "#eef3e6",
  star: "#FF7B1C",
  starEmpty: "#dfe3e7",
};

export const MIN_AVERAGE_TO_DISPLAY = 4;

export const REVIEW_WINDOW_DAYS = 30;

export const MAX_COMMENT = 600;

export const DIMENSIONS = [
  { key: "freshness", label: "How was the freshness & quality?" },
  { key: "delivery", label: "How was the delivery experience?" },
  {
    key: "support",
    label: "How was our support team?",
    allowNA: true,
    hint: "Choose N/A if you didn't contact support",
  },
  { key: "recommend", label: "Would you recommend us to a friend?" },
];
